import { ApplicationDetailsResponse } from "../layouts/applicationDetails/ApplicationDetails.state";
import { get } from "../lib/fetchUtil";

export interface Application {
  applicationId: string;
  applicationNumber?: number;
  name: string;
  type: string;
  status: string;
  created: string;
  updated?: string;
}

export async function fetchApplications(): Promise<Application[]> {
  const response = await get(`insuranceApplication/getApplications`);

  return response.json();
}

export async function getApplication(applicationId: string): Promise<ApplicationDetailsResponse> {
  const response = await get(`insuranceApplication/getApplication/${applicationId}`);

  if (response.status === 200 || response.status === 400) {
    return (await response.json()) as ApplicationDetailsResponse;
  } else {
    throw Error("FAILED_FETCH_GET_APPLICATION");
  }
}
